export default "__VITE_ASSET__DJ$zRLV$__"